import Card from '../components/base/Card';
import Button from '../components/base/Button';

export default function AboutUsPage() {
  const team = [
    { id: 1, name: 'Josep', role: 'Founder & CEO', img: '/team/nikola.jpg' },
    { id: 2, name: 'Ana', role: 'Lead Developer', img: '/team/ana.jpg' },
    { id: 3, name: 'Marko', role: 'Marketing Head', img: '/team/marko.jpg' },
  ];

  return (
    <section className="bg-white">
      {/* Hero / Intro */}
      <div className="max-w-7xl mx-auto px-4 py-16 sm:px-6 lg:px-8 grid lg:grid-cols-2 gap-12 items-center">
        <div>
          <h1 className="text-4xl font-bold text-gray-900 mb-4">About Us</h1>
          <p className="text-lg text-gray-600 mb-6">
            We are a leading company in crypto education and exchange reviews. Our goal is to provide accurate and reliable information to our users.
          </p>
          <Button className="mt-4" size="md">Contact Us</Button>
        </div>
        <div className="flex justify-center">
          <img src="/images/about-hero.png" alt="About Us" className="rounded-lg shadow-lg" />
        </div>
      </div>

      {/* Mission / Vision */}
      <div className="max-w-7xl mx-auto px-4 py-16 sm:px-6 lg:px-8">
        <h2 className="text-3xl font-bold text-gray-900 mb-8 text-center">Our Mission & Vision</h2>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          <Card className="p-6 text-center">
            <h3 className="font-semibold text-xl mb-2">Our Mission</h3>
            <p className="text-gray-600">To educate and empower crypto enthusiasts globally.</p>
          </Card>
          <Card className="p-6 text-center">
            <h3 className="font-semibold text-xl mb-2">Our Vision</h3>
            <p className="text-gray-600">To become the most trusted source for crypto exchange insights.</p>
          </Card>
          <Card className="p-6 text-center">
            <h3 className="font-semibold text-xl mb-2">Our Values</h3>
            <p className="text-gray-600">Transparency, reliability, and innovation in everything we do.</p>
          </Card>
        </div>
      </div>

      {/* Team */}
      <div className="bg-gray-50 py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <h2 className="text-3xl font-bold text-gray-900 mb-8 text-center">Meet Our Team</h2>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            {team.map(member => (
              <Card key={member.id} className="p-6 text-center">
                <img src={member.img} alt={member.name} className="w-24 h-24 rounded-lg mx-auto mb-4" />
                <h3 className="font-bold text-lg text-gray-900">{member.name}</h3>
                <p className="text-gray-600">{member.role}</p>
              </Card>
            ))}
          </div>
        </div>
      </div>

      {/* CTA */}
      <div className="py-16 text-center bg-white">
        <h2 className="text-3xl font-bold text-gray-900 mb-4">Want to work with us?</h2>
        <p className="text-gray-600 mb-6">Reach out today and let’s build something great together.</p>
        <Button size="lg">Get in Touch</Button>
      </div>
    </section>
  );
}
